(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["materials-book"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.materials-book');
  if(!root) return;

  var rail = root.querySelector('.materials-book__rail');
  var railButtons = root.querySelectorAll('.materials-book__rail-link');
  var sections = root.querySelectorAll('.materials-book__category');

  rail.addEventListener('click', function(e){
    var b = e.target.closest('[data-target]');
    if(!b) return;
    var target = root.querySelector('#' + CSS.escape(b.dataset.target));
    if(target) target.scrollIntoView({behavior: 'smooth', block: 'start'});
  });

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var id = entry.target.id;
          railButtons.forEach(function(b){ b.classList.toggle('is-active', b.dataset.target === id); });
        }
      });
    }, {rootMargin: '-15% 0px -70% 0px'});
    sections.forEach(function(s){ io.observe(s); });
  }
  if(railButtons[0]) railButtons[0].classList.add('is-active');

  var drawer = root.querySelector('[data-drawer]');
  var scrim = root.querySelector('[data-scrim]');
  var lastFocused = null;

  function weightDots(w){
    var n = parseFloat(w);
    if(!n){ return '—'; }
    n = Math.round(n);
    var html = '<span class="materials-book__scale"><span class="materials-book__scale-word">Light</span><span class="materials-book__scale-dots">';
    for(var i = 1; i <= 5; i++){
      html += '<span class="' + (i <= n ? 'is-filled' : '') + '"></span>';
    }
    html += '</span><span class="materials-book__scale-word">Heavy</span></span>';
    return html;
  }

  function openDrawer(btn){
    lastFocused = document.activeElement;
    var d = btn.dataset;

    root.querySelector('[data-drawer-cat]').textContent = d.category || '';
    root.querySelector('[data-drawer-name]').textContent = d.name || '';

    var altEl = root.querySelector('[data-drawer-alt]');
    altEl.textContent = d.alt || '';
    altEl.style.display = d.alt ? '' : 'none';

    var descEl = root.querySelector('[data-drawer-desc]');
    if(d.copyNeeded === 'true' || !d.description){
      descEl.textContent = 'Descriptive copy for ' + d.name + ' hasn’t been written yet.';
      descEl.classList.add('is-placeholder');
    } else {
      descEl.textContent = d.description;
      descEl.classList.remove('is-placeholder');
    }

    var specsHtml = '<div class="materials-book__spec-row"><dt>Composition</dt><dd>' + (d.composition || '—') + '</dd></div>';
    if(d.weight){
      specsHtml += '<div class="materials-book__spec-row"><dt>Weight</dt><dd>' + weightDots(d.weight) + '</dd></div>';
    }
    specsHtml += '<div class="materials-book__spec-row"><dt>Features</dt><dd>' + (d.features || '—') + '</dd></div>';
    root.querySelector('[data-drawer-specs]').innerHTML = specsHtml;

    var hero = root.querySelector('[data-drawer-hero]');
    var tile = btn.querySelector('.materials-book__tile');
    hero.setAttribute('data-texture', tile ? tile.getAttribute('data-texture') : '');
    if(d.imageSrc){
      hero.innerHTML = '<img src="' + d.imageSrc + '" alt="' + (d.name || '') + '" loading="lazy">';
    } else {
      hero.innerHTML = '';
    }

    var cta = root.querySelector('[data-drawer-cta]');
    if(d.collectionUrl){
      cta.href = d.collectionUrl;
      cta.style.display = '';
    } else {
      cta.style.display = 'none';
    }

    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    root.querySelector('[data-drawer-close]').focus();
  }

  function closeDrawer(){
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if(lastFocused) lastFocused.focus();
  }

  root.querySelectorAll('.materials-book__swatch').forEach(function(btn){
    btn.addEventListener('click', function(){ openDrawer(btn); });
  });
  root.querySelector('[data-drawer-close]').addEventListener('click', closeDrawer);
  scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
